import { Box, Container, Grid, IconButton, Paper, Stack, Typography } from "@mui/material";
import ScreenBanner from "../../../../../components/ScreenBanner";
import { useCallback, useEffect, useRef, useState, useMemo } from "react";
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import { colunas } from "../dataGridConfig";
import DialogRegistrarRecebimento from "../DialogRegistrarRecebimento";
import DialogListarTodas from "../../../../../components/DialogListarTodas";
import BtnExportar from "../../../../../components/BtnExportar";
import DownloadDoneIcon from '@mui/icons-material/DownloadDone';
import ListaAcoesRapidas, { TItemAcaoRapida } from "../../../../../components/ListaAcoesRapidas";
import PersonPinOutlinedIcon from '@mui/icons-material/PersonPinOutlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import { TOpcoesVisualizacao } from "../../..";
import TableTitulosReceber from "./TableTitulosReceber";
import BackdropTable from "../../../../../components/BackdropTable";
import { useModalDetalheTitulo } from "../ModalDetalheTituloContext";
import PreFiltros from "../PreFiltrosListagens";
import AddIcon from '@mui/icons-material/Add';
import DialogIncluirRecebimento from "../DialogIncluirRecebimento";
import useSetParamsURL from "../../../../../lib/useSetParamsURL";
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import { TableDataGridV2 } from "../../../../../components/TableDataGridV2";
import React from "react";
import moment from "moment";
import PermissionGuard, { usePermission } from "../../../../../components/PermissionGuard";

export default function Listagem() {

    const [openFullScreen, setOpenFullScreen] = useState(false);
    const [openRegistrarDialog, setOpenRegistrarDialog] = useState(false);
    const [openIncluirDialog, setOpenIncluirDialog] = useState(false);
    const [preFilter, setPreFilter] = useState(true);
    const [preVisualizacao, setPreVisualizacao] = useState<TOpcoesVisualizacao | null>(null);

    const { openModal } = useModalDetalheTitulo();
    const { setParamsUrl, searchParams, setMultipleParamsUrl } = useSetParamsURL()

    const containerRef = useRef<HTMLDivElement>(null);

    const handleChangePreFilters = (value: TPreFilters) => {
        const filteredValues: Record<string, any> = {};

        Object.entries(value).forEach(([key, value]) => {
            if (value === null || value === "" || (Array.isArray(value) && value.length === 0) || value === "null" || value === 'undefined' || value === undefined) {
                filteredValues[key] = ""
                return
            }
            if (moment.isMoment(value)) {
                filteredValues[key] = value.format("YYYY-MM-DD");
            } else {
                filteredValues[key] = value;
            }
        });
        setMultipleParamsUrl(filteredValues);
        if (containerRef.current) {
            containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }


    const handleSelectFilters = useCallback((arg: TPreFilters) => {
        setMultipleParamsUrl(arg)
        setPreVisualizacao(null)
    }, [setMultipleParamsUrl])

    const handleClosePreFilter = useCallback(() => {
        setPreFilter(false)
        setPreVisualizacao(null)
    }, [])

    useEffect(() => {
        if (searchParams.size > 0) {
            setPreFilter(false)
        }
    }, [searchParams])

    const listaAcoesRapidas: TItemAcaoRapida[] = [
        {
            label: "Cadastrar título a receber",
            icon: <AddIcon color="primary" />,
            action: () => { setOpenIncluirDialog(true) },
            havePermission: usePermission("financeiro.incluir-titulo-receber")
        },
        {
            label: "Registrar recebimento",
            icon: <DownloadDoneIcon color="primary" />,
            action: () => setOpenRegistrarDialog(true),
            havePermission: usePermission("financeiro.registrar-recebimento")
        },
        {
            label: "Resumo por público",
            icon: <PersonPinOutlinedIcon color="primary" />,
            action: () => setPreVisualizacao("Por público"),
            havePermission: true
        },
        {
            label: "Resumo por função",
            icon: <PaidOutlinedIcon color="primary" />,
            action: () => setPreVisualizacao("Por função"),
            havePermission: true
        },
        {
            label: "Resumo por departamento",
            icon: <ListAltOutlinedIcon color="primary" />,
            action: () => setPreVisualizacao("Por departamento"),
            havePermission: true
        }
    ]

    const RenderListagem = useMemo(() => {
        const TableComponent = () => (
            <>
                {
                    preFilter &&
                    <Box
                        minHeight={370}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <PreFiltros
                            isListarTodas
                            filtros={searchParams}
                            onSubmitFilters={(values) => {
                                handleChangePreFilters(values)
                                handleClosePreFilter()
                            }}
                        />
                    </Box>
                }
                {
                    !preFilter &&
                    <>
                        <BtnExportar boxProps={{ p: 2 }} />
                        <TableDataGridV2
                            urlParams
                            columns={colunas}
                            url="/financeiro/contas-receber/pesquisar-titulos-receber"
                            queryKey="listar-todos-titulos-receber"
                            pagination="server"
                            onRowDoubleClick={(id) => {
                                setParamsUrl(id.toString(), "detalhe-titulo-receber")
                                openModal(id.toString())
                            }}
                        />
                    </>
                }
            </>
        );

        return React.memo(TableComponent);
    }, [preFilter, openModal]);

    return (
        <>
            <ScreenBanner title="Financeiro" />
            <PermissionGuard permissionId="financeiro.listar-titulo-receber">

                <Container sx={{ mt: 3 }}>
                    <Typography textAlign="center" variant="h5" mb={2}>Títulos a receber</Typography>

                    <Grid container spacing={2}>
                        <Grid size={{xs: 12, md: 3}}>
                            <ListaAcoesRapidas
                                items={listaAcoesRapidas}
                                fullHeight={false}
                            />
                        </Grid>

                        <Grid size={{xs: 12, md: 9}} ref={containerRef} >
                            <Box component={Paper}>
                                <Box display="flex" justifyContent="space-between" alignItems="center" px={3} pt={2}>
                                    <Typography variant="h6">Lista de títulos</Typography>

                                    {
                                        !preFilter &&
                                        <Stack alignItems="flex-end" justifyContent="center" direction="row" gap={2}>
                                            <IconButton sx={{ p: 0 }} aria-label="delete" onClick={() => setPreFilter(true)}>
                                                <TuneOutlinedIcon />
                                            </IconButton>

                                            <IconButton sx={{ p: 0 }} aria-label="delete" onClick={() => setOpenFullScreen(true)}>
                                                <FullscreenIcon />
                                            </IconButton>
                                        </Stack>
                                    }
                                </Box>

                                <RenderListagem />
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
                {
                    preVisualizacao &&
                    <BackdropTable
                        open={Boolean(preVisualizacao)}
                        handleClose={() => setPreVisualizacao(null)}
                        table={<TableTitulosReceber preVisualizacao={preVisualizacao} handleChangePreFilters={handleSelectFilters} />}
                    />
                }

                {
                    openFullScreen &&
                    <DialogListarTodas
                        open={openFullScreen}
                        handleClose={() => setOpenFullScreen(false)}
                        title="Lista de títulos a receber"
                    >
                        <RenderListagem />
                    </DialogListarTodas>
                }

                {
                    openRegistrarDialog &&
                    <DialogRegistrarRecebimento
                        open={openRegistrarDialog}
                        handleClose={() => setOpenRegistrarDialog(false)}
                    />
                }
                {
                    openIncluirDialog &&
                    <DialogIncluirRecebimento
                        open={openIncluirDialog}
                        handleClose={() => setOpenIncluirDialog(false)}
                    />
                }
            </PermissionGuard>
        </>
    )
}

export type TPreFilters = {
    [key: string]: any
}